module.exports = __webpack_public_path__ + "static/media/ebintWhiteText.c2af7e90.png";